import Keycloak from 'keycloak-js'

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
    "url": window.env.IAM_URL,
    "realm": window.env.IAM_REALM,
    "clientId": window.env.IAM_CLIENT_ID,
})
export default keycloak

